import React from 'react'

import NoResultTableImage from '@percent/admin-dashboard/common/assets/images/noResultTable.png'
import NoResultsFromSearchImage from '@percent/admin-dashboard/common/assets/images/noResultsFromSearch.png'
import NoPartnersTableImage from '@percent/admin-dashboard/common/assets/images/noPartnersTable.png'
import NoVettingEventsTableImage from '@percent/admin-dashboard/common/assets/images/noVettingEventsTable.png'
import styles from './NoResultTable.module.scss'
import { NoResultTableProps } from './NoResultTable.types'
import { Text } from '@percent/lemonade'

const tableTypes = [
  {
    type: 'default',
    image: NoResultTableImage
  },
  {
    type: 'validations',
    image: NoResultsFromSearchImage
  },
  {
    type: 'partners',
    image: NoPartnersTableImage
  },
  {
    type: 'vettingEvents',
    image: NoVettingEventsTableImage
  }
]

const sizeTypes = {
  big: styles.bigNoResultTableContainer,
  small: styles.smallNoResultTableContainer
}

const titleSizes = {
  big: styles.title,
  small: styles.smallTitle
}

export function NoResultTable({ text, type, actionsRow, size = 'big' }: NoResultTableProps) {
  return (
    <div className={`${styles.noResultTableContainer} ${sizeTypes[size]}`} data-testid="no-result-table">
      <div className={styles.innerContainer}>
        {(type && type !== 'no-image' && (
          <img alt="no result" src={tableTypes.find(tableType => tableType.type === type)?.image} />
        )) ||
          null}
        <Text dataTestId="no-result-table-text" className={`${styles.text} ${titleSizes[size]}`}>
          {text}
        </Text>
        {actionsRow}
      </div>
    </div>
  )
}
